import { DotLegalSelectOption } from "../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";
import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types";
import gdpr from "./icons/gdpr.svg";
import nis2 from "./icons/nis2.svg?url";
import iso from "./icons/iso.svg";
import ePrivacy from "./icons/ePrivacy.svg";
import dsa from "./icons/dsa.svg";
import ai from "./icons/ai.svg";
import dataAct from "./icons/dataAct.svg";
import cyberact from "./icons/cyberAct.svg";
import isae from "./icons/isae.svg";
import custom from "./icons/custom.svg";
import { FilterOperatorUi } from "@common/api/filterTypes";

export enum FrameworkStatus {
    Ongoing = 2,
    Completed = 3,
    Archived = 4,
    Overdue = 5,
    Planned = 6,
}

export enum FrameworkControlStatus {
    Planned = 1,
    Ongoing = 2,
    ReadyForApproval = 3,
    ApprovedInternally = 4,
    Completed = 5,
    Overdue = 6,
}

export interface FrameworkOverviewModel {
    rows: Array<FrameworkRowViewModel>;
    selectableOwners: Array<DotLegalSelectOption>;
    selectableComplianceAreas: Array<DotLegalSelectOption>;
    selectableGroupCompanies: Array<DotLegalSelectOption>;
    selectableStatus: Array<DotLegalSelectOption>;
    selectableFrameworkTemplates: Array<DotLegalSelectOption>;
}

export interface FrameworkRowViewModel {
    id: string;
    framework: string;
    owner: BaseViewModel;
    complianceAreas: Array<BaseViewModel>;
    groupCompanies: Array<BaseViewModel>;
    numberOfTotalControls: number;
    numberOfCompletedControls: number;
    isCompleted: boolean;
    status: FrameworkStatus;
    progress: number;
    isCertificationRequired: boolean;
    standardFrameworkTemplateId: string | undefined;
}

export interface FrameworkRowTableModel extends FrameworkRowViewModel {
    ownerAsString: string;
    complianceAreaAsString: string;
    groupCompaniesAsString: string;
    statusAsString: string;
}

// Mirrors Backend/Core/Filtering/Frameworks/FrameworkColumns.cs, the shared column vocabulary for saved views and export.
export enum FrameworkColumn {
    Framework = "framework",
    CertificationRequired = "certificationRequired",
    Owner = "owner",
    ComplianceAreas = "complianceAreas",
    GroupCompanies = "groupCompanies",
    Controls = "controls",
    Status = "status",
    Progress = "progress",
}

export const allFrameworkColumns: Array<FrameworkColumn> = Object.values(FrameworkColumn);

export interface FrameworkExportHeader {
    header: string;
    column: FrameworkColumn;
}

// Mirrors FrameworksFilterSnapshot. showOnlyMine is always a boolean because change detection compares key sets.
export interface FrameworksSavedFilter {
    selectFilters: Record<string, Array<string>>;
    filterOperators: Record<string, FilterOperatorUi>;
    showOnlyMine: boolean;
    sortByColumn?: string;
    sortDirection?: "asc" | "desc";
}

export interface CreateFromTemplateViewModel {
    display: boolean;
    data: CreateFromTemplateBaseInfo | undefined;
}

interface CreateFromTemplateBaseInfo {
    frameworkId: string;
    name: string;
    description: string;
    complianceAreaIds: Array<string>;
}

export function getFrameworkImage(frameworkName: string): string {
    if (frameworkName.toLowerCase().includes("gdpr")) {
        return gdpr;
    }
    if (frameworkName.toLowerCase().includes("nis2")) {
        return nis2;
    }
    if (frameworkName.toLowerCase().includes("iso")) {
        return iso;
    }
    if (frameworkName.toLowerCase().includes("ePrivacy")) {
        return ePrivacy;
    }
    if (frameworkName.toLowerCase().includes("digital service act")) {
        return dsa;
    }
    if (frameworkName.toLowerCase().includes("aiact")) {
        return ai;
    }
    if (frameworkName.toLowerCase().includes("dataact")) {
        return dataAct;
    }
    if (frameworkName.toLowerCase().includes("cyberresilience")) {
        return cyberact;
    }
    if (frameworkName.toLowerCase().includes("isae")) {
        return isae;
    }

    return custom;
}
